import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Package, Truck } from "lucide-react"
import Button from "../../common/Button.js"
import { canCreateMlSheet } from "../../../utils/networkMode.js"

const DashboardQuickActionButtons = ({ hubBookingAllowed, user }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const showDispatch = canCreateMlSheet(user)

  const handleDispatchClick = () => {
    navigate("/ml-sheets/add")
  }

  return (
    <>
      {hubBookingAllowed && (
        <Button
          variant="primary"
          mobileIconOnly
          mobileLabel={t("dashboard.booking")}
          icon={Package}
          onClick={() => navigate("/shipments/add")}
        >
          {t("dashboard.booking")}
        </Button>
      )}
      {showDispatch && (
        <Button
          variant="orange"
          mobileIconOnly
          mobileLabel={t("dashboard.dispatch")}
          icon={Truck}
          onClick={handleDispatchClick}
        >
          {t("dashboard.dispatch")}
        </Button>
      )}
    </>
  )
}

export default DashboardQuickActionButtons
